module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_9016.3eaa3c83.png";